var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconBeforeSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.762744 15.912C0.486972 17.0222 0.699104 18.0263 1.34257 18.6697C1.98604 19.3132 2.99013 19.5253 4.09322 19.2283L5.63471 18.8465C6.2004 18.7051 8.70144 16.5293 9.11157 16.1192L16.7401 8.49062C16.7728 8.4673 16.804 8.44103 16.8332 8.41183C16.8624 8.38263 16.8886 8.35149 16.912 8.3188L18.2757 6.95509C19.7182 5.51259 19.7182 3.165 18.2757 1.7225C16.8332 0.280001 14.4856 0.28 13.0431 1.7225L2.11332 12.6522C1.7032 13.0624 1.286 13.8048 1.14458 14.3705L0.762744 15.912ZM16.3028 6.82079L17.2221 5.9015C18.0777 5.0459 18.0777 3.64583 17.2221 2.79023C16.3665 1.93463 14.9664 1.93463 14.1108 2.79023L13.1915 3.70952L16.3028 6.82079ZM12.1309 4.77018L3.18812 13.7129C2.96892 13.9321 2.68607 14.4271 2.60829 14.7311L2.22645 16.2726C2.07796 16.8595 2.14867 17.3404 2.4103 17.602C2.67193 17.8636 3.15984 17.9273 3.73966 17.7858L5.28116 17.404C5.58521 17.3262 6.08019 17.0434 6.29939 16.8242L15.2421 7.88145L12.1309 4.77018Z",
    fill: "#F7931E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconBeforeSave);
export default __webpack_public_path__ + "static/media/EditIconBeforeSave.3581e80c69d2540e943202846d9e633b.svg";
export { ForwardRef as ReactComponent };